// src/utils/movieUtils.js
import defaultMovies from "../data/movies.json";

const MOVIES_KEY = "movies";

export function initializeMovies() {
  if (!localStorage.getItem(MOVIES_KEY)) {
    localStorage.setItem(MOVIES_KEY, JSON.stringify(defaultMovies));
  }
}

export function getAllMovies() {
  initializeMovies();
  return JSON.parse(localStorage.getItem(MOVIES_KEY));
}

export function getMovieById(id) {
  initializeMovies();
  const moviesList = JSON.parse(localStorage.getItem(MOVIES_KEY));
  return moviesList.find((m) => m.id === id);
}

export function addMovie(newMovie) {
  initializeMovies();
  const moviesList = JSON.parse(localStorage.getItem(MOVIES_KEY));
  moviesList.push(newMovie);
  localStorage.setItem(MOVIES_KEY, JSON.stringify(moviesList));
}

// **Función añadida** para borrar una película
export function deleteMovie(id) {
  initializeMovies();
  let moviesList = JSON.parse(localStorage.getItem(MOVIES_KEY));
  moviesList = moviesList.filter((m) => m.id !== id);
  localStorage.setItem(MOVIES_KEY, JSON.stringify(moviesList));
  return moviesList;
}
